'use client';

import { adminClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

import { ac, roles } from './access';
import { heimdallSessionOptions } from './session-options';

export interface HeimdallAuthResult<T = unknown> {
  data: T | null;
  error: {
    message?: string;
    status?: number;
    statusText?: string;
    code?: string;
  } | null;
}

export interface HeimdallSessionResult {
  data: {
    user?: {
      id?: string | null;
      email?: string | null;
      role?: string | null;
    } | null;
    session?: {
      id?: string | null;
      userId?: string | null;
      impersonatedBy?: string | null;
    } | null;
  } | null;
  error: unknown;
  isPending: boolean;
  refetch: () => unknown;
}

export interface HeimdallAuthClient {
  signIn: {
    email: (body: { email: string; password: string }) => Promise<HeimdallAuthResult>;
  };
  signOut: () => Promise<unknown>;
  stopImpersonating: () => Promise<HeimdallAuthResult>;
  useSession: () => HeimdallSessionResult;
}

export function createHeimdallAuthClient(baseURL: string): HeimdallAuthClient {
  const authClient = createAuthClient({
    baseURL,
    sessionOptions: heimdallSessionOptions,
    plugins: [adminClient({ ac, roles })],
  });

  return {
    signIn: {
      email: (body) => authClient.signIn.email(body),
    },
    signOut: () => authClient.signOut(),
    stopImpersonating: () => authClient.admin.stopImpersonating(),
    useSession: () => authClient.useSession(),
  };
}
